// A journal cover: a bound board with a printed plate, drawn entirely in CSS.
//
// Ported from design_handoff_oreia/web/journals-web.jsx with its class names intact — .cvr and the
// .pat-* layers in journals.css are the design, and renaming them here would fork it.

import { coverById, type CoverDesign } from './covers';
import { IconLock } from '../components/Icons';

export type CoverSize = 'sm' | 'md' | 'lg';

export function Cover({
  cover,
  title,
  subtitle,
  size = 'md',
  locked,
}: {
  cover: string | CoverDesign;
  /** Omit to render a blank board — the cover rails show the design, not the journal. */
  title?: string;
  subtitle?: string;
  size?: CoverSize;
  locked?: boolean;
}) {
  const design = typeof cover === 'string' ? coverById(cover) : cover;

  return (
    <div
      className={`cvr ${size} ink-${design.ink} pat-${design.pattern}`}
      style={{ background: design.bg }}
      aria-hidden={title === undefined ? 'true' : undefined}
    >
      <span className="cvr-spine" />
      {design.pattern !== 'none' ? <span className="cvr-pat" /> : null}
      {title !== undefined ? (
        <div className="cvr-plate">
          <span className="cvr-rule" />
          <span className="cvr-title">{title}</span>
          {subtitle ? <span className="cvr-sub">{subtitle}</span> : null}
        </div>
      ) : null}
      {locked ? (
        <span className="cvr-lock">
          <IconLock />
        </span>
      ) : null}
    </div>
  );
}
